import Icon, { EditFilled } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";
import { COLORS } from '../../constants/colors';


interface Props {
    active: boolean;
    setActive?: React.Dispatch<React.SetStateAction<boolean>>;
    color: string;
    editable?: boolean;
    value: string;
    onChange?: any;
    name: string;
    placeholder: string;
    backgroundcolor: string;
    props?: object;
}

const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${(props) => props.backgroundcolor};
    border-radius: 5px;
    color: ${(props) => props.color};
    

     input{
        background-color: ${COLORS.transparent_color1} !important;
        border: none;
        outline: none !important;
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        height: 40px;
        font-size: 0.9em;
        font-weight: 300;
        color: ${(props) => props.color} !important;
        transition: all .5s;
    }


     input::placeholder {
        color: ${(props) => props.color};
        font-weight: 300;
        font-size: 1.05em;
        opacity: 0.7;
    }
    
    .icon {
        color: ${(props) => props.color};
        width: 21px;
        height: 18px;
        opacity: 0.4;
        transition: all .1s;
        margin-right: 15px
    }

     .icon:hover {
        opacity: 0.7;
    }
    `;

const EditableText = ({ color, backgroundcolor, active, value, onChange, name, editable, setActive, props, placeholder }: Props): JSX.Element => {

    return (
        <InputWrapper color={color} backgroundcolor={active ? backgroundcolor : COLORS.black_back_color5} active={active} value={value}>
            <input name={name}  {...props} onChange={!!onChange ? onChange : undefined} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
            {editable && active === false &&
                <EditFilled onClick={editable ? () => setActive!(true) : undefined} className="icon" />
            }
        </InputWrapper>
    );
}

export default EditableText;